const catbreeds = [
  {
    text: "option.breed-pedigree-cat.001",
    value: "Abyssinian"
  },
  {
    text: "option.breed-pedigree-cat.002",
    value: "American Curl"
  },
  {
    text: "option.breed-pedigree-cat.003",
    value: "Asian"
  },
  {
    text: "option.breed-pedigree-cat.004",
    value: "Asian Longhair"
  },
  {
    text: "option.breed-pedigree-cat.005",
    value: "Asian Shorthair"
  },
  {
    text: "option.breed-pedigree-cat.006",
    value: "Balinese"
  },
  {
    text: "option.breed-pedigree-cat.007",
    value: "Bengal"
  },
  {
    text: "option.breed-pedigree-cat.008",
    value: "Birman"
  },
  {
    text: "option.breed-pedigree-cat.009",
    value: "British"
  },
  {
    text: "option.breed-pedigree-cat.010",
    value: "Burmese"
  },
  {
    text: "option.breed-pedigree-cat.011",
    value: "Burmilla"
  },
  {
    text: "option.breed-pedigree-cat.012",
    value: "Chartreux"
  },
  {
    text: "option.breed-pedigree-cat.013",
    value: "Colourpoint hybrid"
  },
  {
    text: "option.breed-pedigree-cat.014",
    value: "Cornish rex"
  },
  {
    text: "option.breed-pedigree-cat.015",
    value: "Cymrix"
  },
  {
    text: "option.breed-pedigree-cat.016",
    value: "Devon rex"
  },
  {
    text: "option.breed-pedigree-cat.017",
    value: "Don Sfinx"
  },
  {
    text: "option.breed-pedigree-cat.018",
    value: "Egyptian Mau"
  },
  {
    text: "option.breed-pedigree-cat.019",
    value: "European"
  },
  {
    text: "option.breed-pedigree-cat.020",
    value: "Exotic"
  },
  {
    text: "option.breed-pedigree-cat.021",
    value: "German rex"
  },
  {
    text: "option.breed-pedigree-cat.022",
    value: "Japanese Bobtail"
  },
  {
    text: "option.breed-pedigree-cat.023",
    value: "Javanese"
  },
  {
    text: "option.breed-pedigree-cat.024",
    value: "Korat"
  },
  {
    text: "option.breed-pedigree-cat.025",
    value: "Kurilian bobtail"
  },
  {
    text: "option.breed-pedigree-cat.026",
    value: "Maine Coon"
  },
  {
    text: "option.breed-pedigree-cat.027",
    value: "Manx"
  },
  {
    text: "option.breed-pedigree-cat.028",
    value: "Neva Masquarade"
  },
  {
    text: "option.breed-pedigree-cat.029",
    value: "Norwegian Forest"
  },
  {
    text: "option.breed-pedigree-cat.030",
    value: "Ocicat"
  },
  {
    text: "option.breed-pedigree-cat.031",
    value: "Persian"
  },
  {
    text: "option.breed-pedigree-cat.032",
    value: "Peterblad"
  },
  {
    text: "option.breed-pedigree-cat.033",
    value: "Ragdoll"
  },
  {
    text: "option.breed-pedigree-cat.034",
    value: "Russian Blue"
  },
  {
    text: "option.breed-pedigree-cat.035",
    value: "Scottish fold"
  },
  {
    text: "option.breed-pedigree-cat.036",
    value: "Selkirk Rex"
  },
  {
    text: "option.breed-pedigree-cat.037",
    value: "Seychellois longhair"
  },
  {
    text: "option.breed-pedigree-cat.038",
    value: "Seychellois shorthair"
  },
  {
    text: "option.breed-pedigree-cat.039",
    value: "Siamese"
  },
  {
    text: "option.breed-pedigree-cat.040",
    value: "Siberian"
  },
  {
    text: "option.breed-pedigree-cat.041",
    value: "Singapura"
  },
  {
    text: "option.breed-pedigree-cat.042",
    value: "Snowshoe"
  },
  {
    text: "option.breed-pedigree-cat.043",
    value: "Sokoke"
  },
  {
    text: "option.breed-pedigree-cat.044",
    value: "Somali"
  },
  {
    text: "option.breed-pedigree-cat.045",
    value: "Sphynx"
  },
  {
    text: "option.breed-pedigree-cat.046",
    value: "Thai"
  },
  {
    text: "option.breed-pedigree-cat.047",
    value: "Turkish"
  },
  {
    text: "option.breed-pedigree-cat.048",
    value: "Turkish Angora"
  },
  {
    text: "option.breed-pedigree-cat.049",
    value: "Turkish Van"
  },
  {
    text: "option.breed-pedigree-cat.050",
    value: "Breed unknown"
  }
]

export default catbreeds
